// removed by extract-text-webpack-plugin
module.exports = {"maincolor":"#3cb8a2","bordercolor":"#7d7e80","errorcolor":"#ff4444","green":"#3cb8a2"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-91eea66e","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"D://tideCloud//civisim-web-wx//src//styles//variables.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/base/headerTitle.vue
// module id = 3wi/
// module chunks = 34